import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import VouchersList from "./VouchersList";
import VoucherShow from "./VoucherShow";

export const vouchers = {
  list: VouchersList,
  show: VoucherShow,
  icon: ConfirmationNumberOutlinedIcon,
  options: { label: "Récompenses" },
};
